// @format

export function initSubmitOnChange(): void {
  $(document).on('change', '.submit-on-change', e => {
    e.stopImmediatePropagation();
    $(e.target).parents("form").submit();
  });
}
